import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/list/styles.scss';export default {
  "list": "_list_zryr8_1",
  "main": "_main_zryr8_9",
  "mainRoot": "_mainRoot_zryr8_16",
  "header": "_header_zryr8_21",
  "projectPopup": "_projectPopup_zryr8_31",
  "iconBox": "_iconBox_zryr8_35",
  "icon": "_icon_zryr8_35",
  "folderIcon": "_folderIcon_zryr8_55",
  "openedIcon": "_openedIcon_zryr8_63",
  "popupIcon": "_popupIcon_zryr8_73",
  "projectPopupMain": "_projectPopupMain_zryr8_79",
  "row": "_row_zryr8_86",
  "avatar": "_avatar_zryr8_93",
  "col": "_col_zryr8_98",
  "name": "_name_zryr8_107",
  "deactivated": "_deactivated_zryr8_116",
  "profession": "_profession_zryr8_126",
  "recordList": "_recordList_zryr8_131",
  "removedBadge": "_removedBadge_zryr8_135"
};